import React, { FC, useMemo } from "react";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import Construct from "../../Assets/construct.svg";
import OfficeBlock from "../../Assets/office-block.svg";
import { CustomButton } from "../../Common/CustomButton";
import { companyType } from "../../../enums/company";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    marginBottom: theme.spacing(2),
  },
  button: {
    flex: "1 0 0",
    maxWidth: 300,
    marginRight: theme.spacing(2),
    padding: theme.spacing(2),
    border: `1.5px solid transparent`,
    "&:focus": {
      borderColor: theme.palette.primary.main,
    },
    "& .MuiButton-label": {
      flexDirection: "column",
      textTransform: "none",
      "& span": {
        fontWeight: 600,
      },
    },
  },
  selected: {
    borderColor: theme.palette.primary.main,
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
  },
}));

interface CompanyTypeProps {
  choise: string;
  handleValue(value: string): void;
}

const CompanyType: FC<CompanyTypeProps> = ({ choise, handleValue }) => {
  const classes = useStyles();
  const options = useMemo(
    () => [
      {
        type: companyType.EXISTING,
        icon: OfficeBlock,
        label: (
          <>
            <Typography component="span">
              Ma société
              <Typography component="span" color="primary">
                {" "}
                est immatriculée
              </Typography>
            </Typography>
          </>
        ),
      },
      {
        type: companyType.CREATE,
        icon: Construct,
        label: (
          <>
            <Typography component="span">
              Créer
              <Typography component="span" color="primary">
                {" "}
                ma société
              </Typography>
            </Typography>
          </>
        ),
      },
    ],
    [],
  );

  return (
    <Box className={classes.container}>
      {options.map(({ type, icon, label }) => {
        const isSelected = type === choise;
        return (
          <CustomButton
            key={type}
            variant="text"
            className={classNames(classes.button, {
              [classes.selected]: isSelected,
            })}
            onClick={() => handleValue(type)}
          >
            <img width={45} src={icon} />
            <Box mt={1}>{label}</Box>
          </CustomButton>
        );
      })}
    </Box>
  );
};

export default CompanyType;
